import { createAction, props } from '@ngrx/store'
import {
  CompanyAPIModel,
  CompanyEntityAPIModel,
  CompanyGroupAdditionalDetailsOrchApiModel,
  EmployeeAdminAssignmentPayload,
  EmployeeAPIModel,
  ScreenConfigApiModel,
  SopSettingsAPIModel
} from '../../models/api.model'

const prefix = '[onboarding]'

export const save_company_action = createAction(
  `${prefix} save_company_action`,
  props<{ company: CompanyAPIModel; routeTo: string }>()
)

export const save_company_success_action = createAction(
  `${prefix} save_company_success_action`,
  props<{ company: CompanyAPIModel; routeTo: string }>()
)

export const resetCompany = createAction('[Onboarding] Reset Company')

export const save_entities = createAction(`${prefix} save_entities`, props<{ entities: CompanyEntityAPIModel[] }>())

export const save_entities_success = createAction(
  `${prefix} save_entities_success`,
  props<{ entities: CompanyEntityAPIModel[] }>()
)

// ----------- STEP 3 — SOP SETTINGS -----------
export const save_sop_settings = createAction(`${prefix} save_sop_settings`, props<{ payload: SopSettingsAPIModel }>())

export const save_sop_settings_success = createAction(`${prefix} save_sop_settings_success`)

// ----------- STEP 4 — EMPLOYEES -----------

export const assign_employee_admins = createAction(
  `${prefix} Assign Employee Admins`,
  props<{
    payload: EmployeeAdminAssignmentPayload
    moveNext?: boolean
  }>()
)

export const assign_employee_admins_success = createAction(
  `${prefix} Assign Employee Admins Success`,
  props<{ moveNext?: boolean }>()
)

// ----------- STEP 5 — SCREEN CONFIG -----------

export const loadScreenConfigByType = createAction('[ScreenConfig] Load By Type', props<{ screenType: string }>())

export const saveScreenConfig = createAction('[ScreenConfig] Save', props<{ config: Partial<ScreenConfigApiModel> }>())

export const saveScreenConfigSuccess = createAction(
  '[ScreenConfig] Save Success',
  props<{ config: ScreenConfigApiModel }>()
)

export const loadScreenConfigsByCompanyGroup = createAction(
  '[ScreenConfig] Load All by Company Group',
  props<{ companyGroupId: string }>()
)

export const loadScreenConfigsByCompanyGroupSuccess = createAction(
  '[ScreenConfig] Load All by Company Group Success',
  props<{ configs: ScreenConfigApiModel[] }>()
)

// ----------- STEP 6 — OTHERS (Placeholder for later) -----------
export const save_others = createAction(
  `${prefix} save_others`,
  props<{ companyGroupId: string; others: CompanyGroupAdditionalDetailsOrchApiModel; completeOnboarding: boolean }>()
)

export const save_others_success = createAction(
  `${prefix} save_others_success`,
  props<{ companyGroup: CompanyAPIModel }>()
)

// ----------- LOAD (EDIT MODE) -----------
export const load_onboarding_success = createAction(
  `${prefix} load_onboarding_success`,
  props<{
    company: CompanyAPIModel
    entities: CompanyEntityAPIModel[]
    sopSettings: SopSettingsAPIModel
    employees: EmployeeAPIModel[]
    others: CompanyGroupAdditionalDetailsOrchApiModel
  }>()
)

export const onboardingGoToNextStep = createAction('[Onboarding] Go To Next Step', props<{ props: any }>())
